import { render, staticRenderFns } from "./collectionStatistics.vue?vue&type=template&id=e5ed0292&scoped=true&"
import script from "./collectionStatistics.vue?vue&type=script&lang=js&"
export * from "./collectionStatistics.vue?vue&type=script&lang=js&"
import style0 from "./collectionStatistics.vue?vue&type=style&index=0&id=e5ed0292&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ed0292",
  null
  
)

export default component.exports